    
      //sp navigation
      (function($) {
        const $body  = $('body');
        const $nav   = $('.sp-navigation');
        const $btn   = $('.header__icon--hamburger');
        const $mask  = $('#mask');
        const $close_btn   = $('.header__icon--close');
        const open   = 'is-open'; 
        // menu open close
        $btn.on( 'click', function() {
          $nav.addClass( open );
          $body.addClass( open );
        });
        $close_btn.on( 'click' , function() {
          $nav.removeClass( open );
          $body.removeClass( open );
        });
        // mask close
        $mask.on('click', function() {
          $nav.removeClass( open );
        });
      } )(jQuery);

      const setFillHeight = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      }

      // resize
      let vw = window.innerWidth;
      window.addEventListener('resize', () => {
        if (vw === window.innerWidth) {
          return;
        }
        vw = window.innerWidth;
        setFillHeight();
      });

      setFillHeight();

      //sp navigation accordion
        $(document).ready(function () {
            $('.navigation-parentlink').on('click', function () {
                const $current = $(this).next('.navigation-childlink');
                $(this).toggleClass('is-open');
                $current.slideToggle();
            });
        });


//cart add
function updateCartNotificationLabels() {
  const optionBlocks = document.querySelectorAll('#cart-notification-product .product-option');
  optionBlocks.forEach((block) => {
    const dt = block.querySelector('dt');
    const dd = block.querySelector('dd');

    if (!dt || !dd) return;
    const label = dt.textContent.trim();
    const value = dd.textContent.trim();

    if (label === 'Color:') {
      dt.textContent = 'カラー：';
    } else if (label === 'Size:') {
      dt.textContent = 'サイズ：';
    } else if (label === 'Condition:') {
      dt.textContent = 'コンディション：';
    }

    if (label === 'Condition:' && value === 'S') {
      dd.textContent = 'S: 新品同様';
    } else if (label === 'Condition:' && value === 'A') {
      dd.textContent = 'A: 未使用に近い';
    } else if (label === 'Condition:' && value === 'B') {
      dd.textContent = 'B: 目立つ使用感なし';
    } else if (label === 'Condition:' && value === 'C') {
      dd.textContent = 'C: やや使用感あり';
    } else if (label === 'Condition:' && value === 'D') {
      dd.textContent = 'D: 使用感あり';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const target = document.querySelector('cart-notification');

  if (!target) return;
  const observer = new MutationObserver(() => {
    updateCartNotificationLabels();
  });
  observer.observe(target, { childList: true, subtree: true });
  updateCartNotificationLabels();
});
